(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .factory('sessionStorage', function () {
        return window.sessionStorage;
      });
})();